import { Tooltip, IconButton, Link } from "@chakra-ui/react";
import { FiDatabase } from "react-icons/fi";
import { AppContext } from "../../AppContext";
import { useContext } from "react";

const AccountDataLink = () => {
  const {  contractAddress } = useContext(AppContext);
 
  return(
    <Tooltip label="View Account Data" aria-label="Data Tooltip" placement="top">
    <Link href={`/address/${contractAddress}`} isExternal>
      <IconButton
        colorScheme="blue"
        size="sm"
          fontSize='25px'
        variant="unstyled"
        icon={<FiDatabase />} // Changed to a 'data' icon
        aria-label="Account Data"
      />
    </Link>
  </Tooltip>
  )
};

export default AccountDataLink;
